<template>
  <div
      ref="toast"
      :class="{
      'solflareDesignerToast tw-p-6 tw-rounded-lg tw-text-black tw-z-[2] tw-bg-white': true,
      'tw-border-red-500': type === 'error',
      'tw-border-green-500': type === 'success',
      'tw-text-red-500': type === 'error',
      'tw-text-green-500': type === 'success',
      show: message,
    }"
  >
    {{ message }}
  </div>
</template>

<script>
export default {
  data() {
    return {
      message: null,
      type: null,
    };
  },
  methods: {
    show({ message, type, timeout = 3000 }) {
      this.message = message;
      this.type = type;

      setTimeout(() => {
        this.message = null;
        this.type = null;
      }, timeout);
    },
  },
};
</script>

<style lang="scss">
.solflareDesignerToast {
  visibility: hidden;
  position: fixed;
  top: 25px;
  right: 25px;
  border: 2px solid gray;
  width: auto;
  height: auto;

  &.show {
    visibility: visible;
    -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
    animation: fadein 0.5s, fadeout 0.5s 2.5s;
  }

  @-webkit-keyframes fadein {
    from {
      right: -500px;
      opacity: 0;
    }
    to {
      right: 25px;
      opacity: 1;
    }
  }

  @keyframes fadein {
    from {
      right: -500px;
      opacity: 0;
    }
    to {
      right: 25px;
      opacity: 1;
    }
  }

  @-webkit-keyframes fadeout {
    from {
      right: 25px;
      opacity: 1;
    }
    to {
      right: -500px;
      opacity: 0;
    }
  }

  @keyframes fadeout {
    from {
      right: 25px;
      opacity: 1;
    }
    to {
      right: -500px;
      opacity: 0;
    }
  }
}

.solflareDesignerToastSave {
  visibility: hidden;
  position: fixed;
  top: calc(50% + 60px);
  left: 50%;
  transform: translate(-50%, -50%);

  &.show {
    visibility: visible;
    -webkit-animation: fadeInCenter 0.3s ease-out, fadeOutCenter 0.3s ease-in 8s;
    animation: fadeInCenter 0.3s ease-out, fadeOutCenter 0.3s ease-in 8s;
  }

  @-webkit-keyframes fadeInCenter {
    from {
      transform: translate(-50%, -50%) scale(0.8);
      opacity: 0;
    }
    to {
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
    }
  }

  @keyframes fadeInCenter {
    from {
      transform: translate(-50%, -50%) scale(0.8);
      opacity: 0;
    }
    to {
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
    }
  }

  @-webkit-keyframes fadeOutCenter {
    from {
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
    }
    to {
      transform: translate(-50%, -50%) scale(0.8);
      opacity: 0;
    }
  }

  @keyframes fadeOutCenter {
    from {
      transform: translate(-50%, -50%) scale(1);
      opacity: 1;
    }
    to {
      transform: translate(-50%, -50%) scale(0.8);
      opacity: 0;
    }
  }
}
</style>
